export const getPlanetHdCompanyPeriodId = (access) =>
  access?.company_period?.period_id || access?.company_period_id || ''

export const getPlanetHdAccessIdentity = (access) => JSON.stringify([
  access?.access_id || '',
  getPlanetHdCompanyPeriodId(access),
  access?.geometry_hash || '',
])

export const doesPlanetHdSelectionMatchAccess = (selection, access) => {
  if (!access?.access_id) return false
  const companyPeriodId = getPlanetHdCompanyPeriodId(access)
  if (companyPeriodId) {
    return selection?.accessId === access.access_id &&
      selection?.companyPeriodId === companyPeriodId &&
      (!selection?.geometryHash || selection.geometryHash === access.geometry_hash) &&
      (!access.company_period_id || access.company_period_id === companyPeriodId)
  }
  // Legacy payloads had no commercial binding. Preserve them until the API
  // provides a period, at which point an unbound saved selection is invalid.
  return !selection?.companyPeriodId &&
    (!selection?.accessId || selection.accessId === access.access_id)
}
